<div class="cell-text-wrapper">
  <div [title]="cellText" class="text-ellipsis">{{cellText}}</div>
</div>
